export const FOOTER_TAGLINE = "FOOTER_TAGLINE";
export const FOOTER_QUICK_LINKS = "FOOTER_QUICK_LINKS";
export const FOOTER_LEGAL = "FOOTER_LEGAL";
